<style scoped>

</style>

<template>
  <mu-paper :z-depth="1">
    <ChannelItem 
      :channelId="channel._id" 
      :mediaId="mediaId"
      panel
      />
  </mu-paper>
</template>

<script>

import ChannelItem from '@/components/Channel/Item/Main.vue'

export default {
    name: 'PlaylistPanel',
    components: {
      ChannelItem
    },
    props: {
      channel: {
        type: Object
      },
      mediaId: {
        type: String
      },
    },
    data() {
      return {
      }
    },
    computed: {
    },
    watch: {
      
    },
    mounted() {
      
    },
    methods: {
        
    },
}
</script>
